export const environment = {
  production: true,
  apiUrl: 'https://vdv-api-develop.tccapps.nl/api',
  erpUrl: 'https://erp-develop.tccapps.nl',
  auth: {
    clientId: '30e4be05-420c-11f0-bd61-525400e3798a',
    clientSecret: 'Qcp8c2evgKQtPkP1DuVCQAGiV48LifYyRUETAl9M',
    redirectUri: 'https://vandijk-koppels-develop.tccapps.nl/callback',
    oauthServerUrl: 'https://vdv-api-develop.tccapps.nl',
    scope: '',
  }
};
